import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\SendInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/SendInvoiceController.php
* @route '/api/send-invoice'
*/
const SendInvoiceController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendInvoiceController.url(options),
    method: 'post',
})

SendInvoiceController.definition = {
    methods: ["post"],
    url: '/api/send-invoice',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\SendInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/SendInvoiceController.php
* @route '/api/send-invoice'
*/
SendInvoiceController.url = (options?: RouteQueryOptions) => {
    return SendInvoiceController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\SendInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/SendInvoiceController.php
* @route '/api/send-invoice'
*/
SendInvoiceController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendInvoiceController.url(options),
    method: 'post',
})

export default SendInvoiceController